module.exports = __webpack_public_path__ + "static/img/admin.6d831f8e.png";